"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MultiSelect = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const react_jss_1 = __importDefault(require("react-jss"));
const hooks_1 = require("../../utils/hooks");
const icons_1 = require("../../icons");
const __1 = require("..");
const multiSelect_style_1 = __importDefault(require("./multiSelect.style"));
const MultiSelect = ({ classes, dataCy = 'multiselect', options, selectedValues, onSelect, displayValue = '', compact = false, hideLabel = true, disabled = false, invalid = false, displayLabelIfOneSelected = false, 
// @ts-ignore only used within the stylesheet
shadows = false }) => {
    const selectBtn = react_1.useRef(null);
    const [isFocused, setFocus] = react_1.useState(false);
    // enable clicking outside the MultiSelect to close its options.
    hooks_1.useOnClickOutside(selectBtn, () => blur());
    // close its options when pressing the escape key.
    hooks_1.useKeyPress('Escape', () => blur());
    const focus = react_1.useCallback(() => {
        if (!disabled && !isFocused)
            setFocus(true);
    }, [disabled, isFocused]);
    const blur = react_1.useCallback(() => {
        setFocus(false);
        if (selectBtn && selectBtn.current)
            selectBtn.current.focus(); // keep the selectBtn focused until explicitely blurred
    }, []);
    // handle clicking on one item
    const selectMultipleItems = react_1.useCallback((value) => {
        const newValues = [...selectedValues];
        const valueIndex = newValues.findIndex(item => item === value);
        if (valueIndex > -1) {
            newValues.splice(valueIndex, 1);
        }
        else {
            newValues.push(value);
        }
        return onSelect(newValues);
    }, [selectedValues, onSelect]);
    const handleOnSelect = react_1.useCallback((value) => selectMultipleItems(value), [selectMultipleItems]);
    // get label to display
    const textDisplay = react_1.useMemo(() => {
        var _a;
        let disp = `No ${displayValue} selected`;
        const nbValuesSelected = selectedValues === null || selectedValues === void 0 ? void 0 : selectedValues.length;
        if (nbValuesSelected) {
            if (displayLabelIfOneSelected && nbValuesSelected === 1) {
                const [firstValue] = selectedValues;
                disp = ((_a = options.find(({ value }) => value === firstValue)) === null || _a === void 0 ? void 0 : _a.label) || '';
            }
            else {
                disp = `${`${selectedValues.length} ${displayValue}`}${selectedValues.length > 1 ? 's' : ''} selected`;
            }
        }
        return disp;
    }, [displayValue, selectedValues, options, displayLabelIfOneSelected]);
    // build the list of options to display when focused
    const optionsList = options.map(item => {
        const isSelected = (selectedValues === null || selectedValues === void 0 ? void 0 : selectedValues.length) > 0 &&
            selectedValues.filter(el => el === item.value).length > 0;
        const handleChange = () => handleOnSelect(item.value);
        return (jsx_runtime_1.jsx("div", Object.assign({ className: classes.option, "data-is-selected": isSelected }, { children: jsx_runtime_1.jsx(__1.Check, { label: item.label, checked: isSelected, showLabel: true, largeLabel: true, handleChange: handleChange }, void 0) }), item.value));
    });
    const renderClosedDropdown = react_1.useMemo(() => compact ? (jsx_runtime_1.jsx(__1.FieldSelectCompact, Object.assign({ onValueChange: () => { }, value: "", label: displayValue, disabled: disabled, invalid: invalid }, { children: jsx_runtime_1.jsx(__1.OptionDrop, { label: textDisplay, value: textDisplay, selected: options.length > 0 }, void 0) }), void 0)) : (jsx_runtime_1.jsx(__1.Dropdown, Object.assign({ onValueChange: () => { }, value: "", label: selectedValues.length > 0 ? textDisplay : `${displayValue}s`, hideLabel: hideLabel, disabled: disabled, invalid: invalid }, { children: jsx_runtime_1.jsx(__1.OptionDrop, { label: displayValue, value: "" }, void 0) }), void 0)), [
        compact,
        hideLabel,
        options.length,
        selectedValues.length,
        displayValue,
        textDisplay,
        disabled,
        invalid
    ]);
    const renderOpenedDropdown = react_1.useMemo(() => (jsx_runtime_1.jsxs("div", Object.assign({ className: classes.multiselectInputDropDown }, { children: [jsx_runtime_1.jsxs("div", Object.assign({ className: classes.tooltipHeader, onClick: blur, "data-cy": "multiselect-blur" }, { children: [jsx_runtime_1.jsx("div", Object.assign({ "data-cy": "multiselect-placeholder", className: classes.textDisplay }, { children: options.length && textDisplay }), void 0),
                    jsx_runtime_1.jsx("div", Object.assign({ className: classes.multiselectDropdownIcon, "data-input-focused": isFocused }, { children: jsx_runtime_1.jsx(icons_1.icons.ArrowDownFill, { size: 17 }, void 0) }), void 0)] }), void 0),
            jsx_runtime_1.jsx("div", Object.assign({ className: classes.optionsList }, { children: optionsList }), void 0)] }), void 0)), [blur, classes, isFocused, options.length, optionsList, textDisplay]);
    return (jsx_runtime_1.jsx("div", Object.assign({ className: classes.root, "data-input-focused": isFocused, "data-is-set": (selectedValues === null || selectedValues === void 0 ? void 0 : selectedValues.length) > 0, onClick: focus, ref: selectBtn, "data-cy": dataCy }, { children: !isFocused ? renderClosedDropdown : renderOpenedDropdown }), void 0));
};
exports.MultiSelect = MultiSelect;
exports.default = react_jss_1.default(multiSelect_style_1.default)(exports.MultiSelect);
//# sourceMappingURL=index.js.map